"use client";

import * as Sentry from "@sentry/react";
import { type PropsWithChildren } from "react";

import { getBuildEnv } from "../utils/sentry";
import { ErrorReporter } from "./createErrorHandler";
import { ErrorFallbackSentry } from "./ErrorFallbackSentry";

export type SentryErrorBoundaryProps = PropsWithChildren<{ errorHandlerReport: ErrorReporter }>;

export const SentryErrorBoundary = ({ errorHandlerReport, children }: SentryErrorBoundaryProps) => (
  <Sentry.ErrorBoundary
    fallback={ErrorFallbackSentry}
    showDialog={getBuildEnv() !== "prd"}
    // Sentry.ErrorBoundary 自身が Sentry へ送るため、二重送信しないよう Stackdriver にだけ送る
    onError={(error) => errorHandlerReport(error as Error, { skipSentry: true })}
  >
    {children}
  </Sentry.ErrorBoundary>
);
